/* eslint-disable prettier/prettier */
import axios from "axios";
import moment from "moment";


//import { TokenService } from "../services/storage.service";

const ApiService = {
  init(baseURL) {
    axios.defaults.baseURL = baseURL;
    axios.defaults.withCredentials = true

    // declare a request interceptor
    axios.interceptors.request.use(config => {
      // perform a task before the request is sent
      console.log('Request was sent');

      return config;
    }, error => {
      // handle the error
      return Promise.reject(error.response);
    });


    axios.interceptors.response.use((response) => {
      // do something with the response data
      console.log('Response was received');
    
      return response;
    }, error => {
      // handle the response error
      console.log('Response error',error);
      
      if(error.response.status == 403)
        location.href="/#/info";

      if(error.data == null)
        error.data = {};

      error.data.message = error.data.message == null ? 'Hmmmm, something went wrong! Please try again.' : error.data.message;
      return Promise.reject(error.response);
    });
  },

  
  /*
  setHeader() {
    axios.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`;
  },
*/
  removeHeader() {
    axios.defaults.headers.common = {};
  },

  getTodaysMemries() {
    var today = moment().format("YYYY-MM-DD");
    console.log("Get TOdays Memries", today);
    return axios.get("/memries/today");
  },

  getMemries(filter,limit) {
    var filterstr = filter ? '&filter=' + filter : '';
    var limitstr = limit ? '&limit=' + limit : '';
    //var skipstr = skip ? '&skip=' + skip : '';
    return axios.get('/memries?active=1' + filterstr + limitstr);
  },

  getMemriesByTag(tagid) {
    return axios.get('/memries?active=1&tagid=' + tagid);
  },

  getDrafts() {
    return axios.get('/memries?active=0');
  },


  getAllMemries() {
    return axios.get('/memries/');
  },

  getMemryStats() {
    return axios.get('/memries/stats');
  },


  getTags(parentid) {
    if(!parentid)
      return axios.get('/tags/');

    return axios.get('/tags?parentid=' + parentid);
  },


  getMemry(memryid) {
    return axios.get('/memries/' +  memryid);
  },

  createMemry(memry) {
    return axios.post('/memries/',memry);
  },

  createTag(tag) {
    return axios.post('/tags/',tag);
  },

  updateTag(tag) {
    return axios.post('/tags/',tag);
  },

  deleteTag(tag,replacetag) {
    let replaceprm = '';
    if(replacetag != null && replacetag.id != null)
      replaceprm = '?replaceid=' + replacetag.id;

    return axios.delete('/tags/' + tag.id + replaceprm);
  },

  updateBatchScore(batch) {
    return axios.put('/memries/score',batch);
  },
  
  updateMemryScore(memry) {
    return axios.put('/memries/' + memry.id + '/score',memry);
  },

  registerUser(user) {
    user.datecreated = moment().format('YYYY-MM-DD');
    return axios.post('/auth/user',user);
  },

  getSession() {
    return axios.get('/session');
  },

  login(user) {
    return axios.post('/auth/login',user);
  },

  validateGAuth(token) {
    return axios.post('/auth/gtoken',{"token": token, "requestdate": moment()});
  },


  logout(user) {
    return axios.post('/auth/logout',user);
  },
  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  customRequest(data) {
    return axios(data);
  }
};

export default ApiService;